import React, { useState } from 'react';
import PropTypes from 'prop-types';
import makeRequest from 'utils/makeRequest';
import SocialSharingMobile from 'routes/articleshow_v2/components/mobile/SocialSharingMobile';
import { gaWrapper } from 'helpers/analytics';
import Cookie from 'utils/cookies';
import PollResult from './PollResult';
import PollSuccessLoginBlocker from './PollSuccessLoginBlocker';
import SocialSharingWeb from '../../../../articleshow_v2/components/desktop/SocialSharingWeb';

import s from './TimelinePoll.scss';
import InViewObserver from '../../../../../components/InViewObserver/InViewObserver';
import analyticsWrapper from '../../../../../helpers/analytics/analyticsWrapper';

const renderPollQuestions = (
  options,
  hl,
  selectOption,
  submitPoll,
  selectedOption,
  msid,
) => (
  <>
    <div className={s.poll_inner}>
      <div className={s.pollAction}>
        {options instanceof Array &&
          options.map(val => (
            <label
              htmlFor={`${msid}_${val.id}`}
              className={
                selectedOption && val.id === selectedOption.id && s.active
              }
            >
              <input
                type="radio"
                name={msid}
                key={`${msid}_${val.id}`}
                value={val.name}
                id={`${msid}_${val.id}`}
                onChange={() => selectOption(val)}
              />
              {val.name}
            </label>
          ))}
        {/* {isLoggedIn && (
          <button
            onClick={() => {
              submitPoll();
            }}
            className={`${s.submitPoll}  ${
              selectedOption != null ? s.active : ''
            }`}
          >
            SUBMIT
          </button>
        )} */}
      </div>
    </div>
  </>
);

const TimelinePoll = props => {
  const {
    data: { options, title, msid, hl, id },
    isLoggedIn,
    toggleLoginBox,
    isWapView,
    hideShareFeature,
    pollSubmitCallback,
    dataUrl,
    isElectionPoll,
    // pollDone,
    tpShow,
    url,
    sharingtitle,
    ga4Type,
    ga4Category,
  } = props;

  const [selectedOption, setOption] = useState(null);
  const [pollResult, setPollResult] = useState(null);

  const submitPoll = optionData => {
    // if (props.newga && typeof props.newga === 'string') {
    //   gaWrapper('send', 'event', ...props.newga.split('#'));
    // }
    const selected = optionData || selectedOption;
    if (!(selected && selected.id)) {
      return;
    }
    const selectedOptionId = selected.id;
    const postObj = `txtPolliD=${msid || id}&PRadio=${selectedOptionId}`;
    let pollPostEndpoint;
    /************TODO Move api url from here to some constants*****************/
    if (__PROD__) {
      pollPostEndpoint = `https://timesofindia.indiatimes.com/vote_json.cms`;
    } else {
      pollPostEndpoint = `https://toidev.indiatimes.com/vote_json.cms`;
    }
    /************TODO Move api url from here to some constants*****************/

    makeRequest.post(pollPostEndpoint, postObj).then(response => {
      if (response.status === 200) {
        if (props.newga && typeof props.newga === 'string') {
          gaWrapper('send', 'event', ...props.newga.split('#'));
        }
        setPollResult(response.data);
        if (typeof pollSubmitCallback === 'function') {
          pollSubmitCallback();
        }
      }
    });
    // if (typeof ga4Type !== 'undefined' && ga4Type !== '') { firing twice
    //   analyticsWrapper('ga4', {
    //     event: 'user_click',
    //     type: 'poll',
    //     category: 'poll_submit',
    //   });
    // }
  };

  // eslint-disable-next-line no-unused-vars
  const getPollResults = () => {
    let pollPostEndpoint;
    /************TODO Move api url from here to some constants*****************/
    if (__PROD__) {
      pollPostEndpoint = `https://timesofindia.indiatimes.com/vote_json.cms`;
    } else {
      pollPostEndpoint = `https://toidev.indiatimes.com/vote_json.cms`;
    }
    /************TODO Move api url from here to some constants*****************/

    makeRequest
      .get(`${pollPostEndpoint}?txtPolliD=${msid || id}`)
      .then(response => {
        if (response.status === 200) {
          setPollResult(response.data);
        }
      });
  };

  // useEffect(() => {
  //   if (pollDone) {
  //     getPollResults();
  //   }
  // }, []);

  const selectOption = e => {
    const optionData = { id: e.id, value: e.name };
    if (typeof ga4Type !== 'undefined' && ga4Type !== '') {
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: `${ga4Type}`,
        category: 'option_select',
        msid: msid || id,
        page_title: hl,
        login_status: isLoggedIn,
      });
    }
    setOption(optionData);
    submitPoll(optionData);
  };

  const questions =
    options instanceof Array &&
    options
      .map(item => ({ id: item.id, name: item.text }))
      .sort((a, b) => a.id - b.id);
  if (!isLoggedIn && pollResult) {
    sessionStorage.setItem('pollResultID', pollResult?.pollid);
    sessionStorage.setItem('pollResult', JSON.stringify(pollResult));
    sessionStorage.setItem('selectedOption', JSON.stringify(selectedOption));
  }
  if (
    isLoggedIn &&
    !pollResult &&
    sessionStorage.getItem('pollResult') &&
    sessionStorage.getItem('selectedOption') &&
    sessionStorage.getItem('previousPage') === window?.location?.pathname
  ) {
    const pollResultJSON = sessionStorage.getItem('pollResult');
    const pollOptionJSON = sessionStorage.getItem('selectedOption');
    // sessionStorage.removeItem('pollResult');
    //sessionStorage.removeItem('selectedOption');
    if (pollResultJSON && pollOptionJSON) {
      const previouspollResultInfo = JSON.parse(pollResultJSON);
      const previousselectedOptionInfo = JSON.parse(pollOptionJSON);
      setPollResult(previouspollResultInfo);
      setOption(previousselectedOptionInfo);
    }
  }
  /// Set poll result by localstorage
  // const showHeading =
  // ((title || hl) && (pollResult && isLoggedIn)) || !pollResult;

  return (
    <div
      className={`${s.timeline_pollWrapper} timeline_pollWrapper_as ${
        pollResult && !isLoggedIn ? s.PollSuccessLoginBlocker : ''
      }`}
      data-scrollga="scroll#poll_view"
    >
      <div className={s.poll_mweb_fix}>
        <div className={s.poll_icons}>Poll</div>
        {/* {showHeading && <div className={s.question}>{title || hl}</div>} */}
        <div className={s.question}>{title || hl}</div>
        <InViewObserver
          inViewCallback={() => {
            const isPollAlreadyDone = Cookie.get(`POLLID${msid || id}`)
              ? 'loggedin_polled'
              : 'loggedin_nonpolled';
            if (ga4Type) {
              analyticsWrapper('ga4', {
                event: 'user_shown',
                category: `${ga4Category}`,
                label: isLoggedIn ? isPollAlreadyDone : 'nonloggedin',
                type: `${ga4Type}`,
                msid: msid || id,
                page_title: hl,
                login_status: isLoggedIn,
              });
            }
          }}
        >
          {!pollResult &&
            renderPollQuestions(
              questions,
              title || hl,
              selectOption,
              submitPoll,
              selectedOption,
              msid || id,
            )}
        </InViewObserver>
        {pollResult &&
          isLoggedIn && (
            <>
              <InViewObserver
                inViewCallback={() => {
                  const pollId = msid || id;
                  Cookie.set(`POLLID${pollId}`, pollId, 1, '/');
                  const isPollAlreadyDone = Cookie.get(`POLLID${pollId}`)
                    ? 'loggedin_polled'
                    : 'loggedin_nonpolled';
                  if (ga4Type) {
                    analyticsWrapper('ga4', {
                      event: 'user_shown',
                      category: `${ga4Category}`,
                      label: isLoggedIn ? isPollAlreadyDone : 'nonloggedin',
                      type: `${ga4Type}`,
                      msid: msid || id,
                      page_title: hl,
                      login_status: isLoggedIn,
                    });
                  }
                }}
              >
                <PollResult
                  selectedOption={selectedOption}
                  data={pollResult}
                  isElectionPoll={isElectionPoll}
                  dataUrl={dataUrl}
                />
              </InViewObserver>
              {!hideShareFeature && (
                <React.Fragment>
                  {!isWapView ? (
                    <SocialSharingWeb
                      textRequired={false}
                      tpShow={tpShow}
                      linkeDin
                      showComment
                      topsticky
                      liveblogMailHeading="Mail this story"
                      title={sharingtitle}
                      url={url}
                      via="@timesofindia"
                    />
                  ) : (
                    <SocialSharingMobile
                      msid={msid || id}
                      title={title || hl}
                      via=""
                      whatsAppShow
                      isWapView
                      isTablet={false}
                      wrapperClass=""
                      gaCategory="liveblog_new_mweb"
                    />
                  )}
                </React.Fragment>
              )}
            </>
          )}
        {pollResult &&
          !isLoggedIn && (
            <PollSuccessLoginBlocker
              toggleLoginBox={toggleLoginBox}
              ga4Type={ga4Type}
              msid={msid || id}
              hl={hl}
            />
          )}
      </div>
    </div>
  );
};

TimelinePoll.propTypes = {
  data: PropTypes.shape({
    options: PropTypes.string,
    title: PropTypes.string,
    hl: PropTypes.string,
  }).isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  toggleLoginBox: PropTypes.func.isRequired,
  isWapView: PropTypes.bool.isRequired,
  hideShareFeature: PropTypes.bool,
  pollSubmitCallback: PropTypes.func,
  dataUrl: PropTypes.string,
  isElectionPoll: PropTypes.bool,
  tpShow: PropTypes.bool,
  ga4Type: PropTypes.string,
  ga4Category: PropTypes.string,
};

TimelinePoll.defaultProps = {
  hideShareFeature: false,
  dataUrl: '',
  pollSubmitCallback: () => {},
  isElectionPoll: false,
  tpShow: true,
  ga4Type: '',
  ga4Category: '',
};

export default TimelinePoll;
